import React from 'react';
import styled from 'styled-components';
import {useFilter} from './context/filterContext';

const StyledLink = styled.a`
  cursor: pointer;
`;

const CatalogFilterListItem = ({filter}) => {
	const {
		filterId, setFilterHandler, choices, draftChoices, ranges, length,
	} = useFilter();
	const isOpen = filterId === filter.id;
	const selected = isOpen
		? (draftChoices[filter.id] ?? choices[filter.id])
		: choices[filter.id];

	let count = selected?.length || 0;
	if (filter.type === 'range') {
		count = ranges[filter.id] ? 1 : 0;
	} else if (filter.type === 'length') {
		count = (length.min || length.max) ? 1 : 0;
	}

	return (
		<li onClick={setFilterHandler(filter.id)}>
			<StyledLink
				className={`catalog__filter-link
			 ${isOpen ? 'is-active' : ''}
			 ${count > 0 ? 'is-involved' : ''}`}
				data-filter-button={`catalog-filter-id--${filter.id}`}
			>
				<span>
					{filter.title}
					{count > 0 && (
						<span className="catalog__filter-link-count">{count}</span>
					)}
				</span>
			</StyledLink>
		</li>
	);
};

export default CatalogFilterListItem;
